/**
 * This enum handle smart component type kind
 */
export enum SmartComponentTypeKind {
  UNKNOWN = "",
  METER = 1,
  THERMOSTAT = 2,
  BLINDS = 3,
  LIGHTS = 4,
  SENSOR = 6,
  ALARM = 7,
  WEATHER_STATION = 8,
  LABEL = 9,
  PAGE_BREAK = 10,
  SCENARIO = 11
}
